export const FONT_FAMILY_OPTIONS = [
  { label: "Inter", value: "'Inter'" },
  { label: "Open Sans", value: "'Open Sans'" },
  { label: "Calibri", value: "Calibri" },
  { label: "Caviar Dreams", value: "'Caviar Dreams'" },
];

export interface FontFamilyOption {
  label: string;
  value: string;
}

export const DEFAULT_FONT_FAMILY = FONT_FAMILY_OPTIONS[0].value;

let companyFontOptions: FontFamilyOption[] | null = null;
let fontFamilyOptions: FontFamilyOption[] = FONT_FAMILY_OPTIONS;

export function setCompanyFontOptions(options: FontFamilyOption[]): void {
  companyFontOptions = options;
  fontFamilyOptions = [...FONT_FAMILY_OPTIONS, ...options];
}

export function resetCompanyFontOptions(): void {
  companyFontOptions = null;
  fontFamilyOptions = FONT_FAMILY_OPTIONS;
}

export function getFontFamilyOptions(): FontFamilyOption[] {
  return fontFamilyOptions;
}

export function isValidFontFamily(font: string): boolean {
  if (!font) return false;
  if (fontFamilyOptions.some((f) => f.value === font)) return true;
  // Polices société pas encore chargées : ne pas écraser une police société déjà enregistrée
  return companyFontOptions === null;
}

export function normalizeFontFamily(font: string): string {
  return isValidFontFamily(font) ? font : DEFAULT_FONT_FAMILY;
}

export const FONT_SIZE_OPTIONS = [
  { label: "Petite", value: "11px" },
  { label: "Moyenne", value: "12px" },
  { label: "Grande", value: "13px" },
];
